import SEOHEAD from "@components/SEOHEAD";
import LeftArrow from "assets/svg/leftArrow.svg";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

import { Title } from "..";

function Articles({ article }: any): JSX.Element {
  const router = useRouter();
  return (
    <>
      <div className="z-10 flex h-auto w-full flex-col px-[10%]">
        <div className="flex w-full justify-between">
          <div className="">
            <Title title="مقالات" wrapperClass="mb-9" />
          </div>
        </div>
        <div className="relative grid h-auto grid-cols-1 gap-x-5 gap-y-6 lg:grid-cols-2 2xl:grid-cols-3">
          {article?.map(({ image, id, title, seoUrlDescription }: any) => (
            <Link
              href={{
                href: `/post/${id}`,
                pathname: seoUrlDescription
                  ? `/post/${id}/${encodeURIComponent(seoUrlDescription)}`
                  : `/post/${id}`,
              }}
              key={JSON.stringify(id)}
            >
              <a>
                <div
                  className="flex h-24 w-full cursor-pointer overflow-hidden rounded-lg bg-white text-black-450"
                  style={{
                    boxShadow: "0px 0px 5px rgba(139, 139, 139, 0.19)",
                  }}
                >
                  <img
                    loading="lazy"
                    src={image}
                    className="aspect-auto object-contain"
                    alt="عکس مقاله"
                  />
                  <div className="flex w-8/12 flex-col justify-evenly overflow-hidden px-2 pt-2 text-sm">
                    <div className="h-full w-full border-b-2 border-blue-550">
                      <p>{title}</p>
                    </div>
                  </div>
                </div>
              </a>
            </Link>
          ))}
        </div>
        <Link
          href={{ href: "/posts", pathname: "/posts/مجله-حقوقی" }}
          aria-label="see more articles"
        >
          <div className="mt-6 flex w-full cursor-pointer items-center justify-end text-blue-550">
            بیشتر بخوانید
            <LeftArrow className="mr-2 fill-[#0577AF]" />
          </div>
        </Link>
      </div>
    </>
  );
}

export default Articles;
